/* tslint:disable */
/* eslint-disable */
/**
 * Plateformes API
 * API for managing plateformes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PlateformeThemeDto } from './PlateformeThemeDto';
import {
    PlateformeThemeDtoFromJSON,
    PlateformeThemeDtoFromJSONTyped,
    PlateformeThemeDtoToJSON,
    PlateformeThemeDtoToJSONTyped,
} from './PlateformeThemeDto';

/**
 * 
 * @export
 * @interface UpdatePlateformeCommand
 */
export interface UpdatePlateformeCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdatePlateformeCommand
     */
    name: string;
    /**
     * 
     * @type {PlateformeThemeDto}
     * @memberof UpdatePlateformeCommand
     */
    theme: PlateformeThemeDto;
}

/**
 * Check if a given object implements the UpdatePlateformeCommand interface.
 */
export function instanceOfUpdatePlateformeCommand(value: object): value is UpdatePlateformeCommand {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('theme' in value) || value['theme'] === undefined) return false;
    return true;
}

export function UpdatePlateformeCommandFromJSON(json: any): UpdatePlateformeCommand {
    return UpdatePlateformeCommandFromJSONTyped(json, false);
}

export function UpdatePlateformeCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePlateformeCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'theme': PlateformeThemeDtoFromJSON(json['theme']),
    };
}

export function UpdatePlateformeCommandToJSON(json: any): UpdatePlateformeCommand {
    return UpdatePlateformeCommandToJSONTyped(json, false);
}

export function UpdatePlateformeCommandToJSONTyped(value?: UpdatePlateformeCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'theme': PlateformeThemeDtoToJSON(value['theme']),
    };
}

